import React, { useContext } from 'react';
import {
  CustomizeSchedulePerProfileView,
  CustomizeSchedulePerProfileViewProps
} from './CustomizeSchedulePerProfile.view';
import { PostEditorContext } from '../states/PostEditorProvider';
import { mapSelectedProfilesValues } from '../helpers/mapSelectedProfilesValues';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';

export type CustomizeSchedulePerProfileControllerProps = {
  // extend your CustomizeSchedulePerProfileViewProps
  formInstance: CustomizeSchedulePerProfileViewProps['formInstance'];
  activeIndex?: CustomizeSchedulePerProfileViewProps['activeIndex'];
  onTabChange?: CustomizeSchedulePerProfileViewProps['onTabChange'];
  postId?: CustomizeSchedulePerProfileViewProps['postId'];
};

export const CustomizeSchedulePerProfileController = (
  props: CustomizeSchedulePerProfileControllerProps
): JSX.Element => {
  // Put All your methods and logic here
  const { state, profiles: socialProfiles } = useContext(PostEditorContext);
  const [tabsState] = useContext(PostEditorGroupDataContext);
  const { postGroupIndex } = tabsState;
  const profiles = state.postGroups[postGroupIndex].profiles;
  // Put All your methods and logic here
  const selectedProfiles = mapSelectedProfilesValues(profiles, socialProfiles);
  const readOnlyPosts = state.postGroups[postGroupIndex].readOnlyPosts;
  const readOnlyProfiles = socialProfiles.filter(p => readOnlyPosts.map(i => i.customizedProfileId).includes(p.id));
  const showPostStatusSelector = !state.postGroups[postGroupIndex].customizeContentPerProfile;

  const viewProps: CustomizeSchedulePerProfileViewProps = {
    ...props,
    selectedProfiles,
    readOnlyPosts,
    readOnlyProfiles,
    showPostStatusSelector
  };
  return <CustomizeSchedulePerProfileView {...viewProps} />;
};
